/***********
 * create by hu at 20230427
 * 延迟加载路由配置
 *
 * 待处理问题：
 * 1，不同类型用户登录变更页面布局
 * 2，不同登录方式变更布局
 *
 * 参数注释：
 * {requiresAuth} 认证路由
 **********/
import {isEmpty} from "../tools/utils";

function getFirstPage(){
    let menus = localStorage.getItem('USER_MENUS') ? JSON.parse(localStorage.getItem('USER_MENUS')) : [];
    let name = '';
    if(!isEmpty(menus)){
        name = menus[0][0]['children'][0]['name']
    }
    if(isEmpty(name)){
        name = 'login'
    }
    return name
}



const routes = [
    { path: '/login/', name: 'login', component: () => import('../views/login.vue') },
    { path: '/sso/', name: 'sso', component: () => import('../views/sso.vue') },
    {
        path: '/', name: 'main', component: () => import('../views/layout/base.vue'), meta: { requiresAuth: true },
        children: [
            { path: '/', name: 'home', component: () => import('../views/home.vue'), meta: { requiresAuth: true },
                redirect: { name: getFirstPage() },
            },
        ]
    },
    // special-offer
    {
        path: '/pam/', name: 'pam', component: () => import('../views/layout/base.vue'), meta: { requiresAuth: true },
        children: [
            {
                path: '/pam/purchase-requisition', name: 'purchaseRequisition', component: () => import('../views/pam/purchase-requisition/index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/pam/special-offer', name: 'specialOffer', component: () => import('../views/pam/special-offer/index.vue'),
                meta: { requiresAuth: true,keepAlive: true }
            },
            {
                path: '/pam/special-offer-details', name: 'specialOfferDetails', component: () => import('../views/pam/special-offer-details/index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: '/pam/eorder-details/:id', name: 'eorderDetails', component: () => import('../views/pam/eorder-details/index.vue'),
                meta: { requiresAuth: true,keepAlive: true }
            },
            {
                path: '/pam/purchase-order', name: 'purchaseOrder', component: () => import('../views/pam/purchase-order/index.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
]


export default routes
